<template>
    <div
        class="d-flex" :style="`font-size: ${size};`">
        <i
            v-for="(item, index) in base"
            :key="index"
            :class="{
                empty: !rating,
                negative: rating && rating <= 2,
                positive: rating > 2,
                active: Math.ceil(rating) >= item,
                fas: !rating,
                fas: (!!rating && !(showHalf && !Number.isInteger(rating) && parseInt(rating) == index)) || !rating,
                fad: showHalf && !Number.isInteger(rating) && parseInt(rating) == index,
                'fa-star': true,
                'fa-star-half': showHalf && !Number.isInteger(rating) && parseInt(rating) == index
            }"
            :style="`color: ${color};`"
        ></i>
    </div>
</template>
<script>
export default {
    data() {
        return {
            base: [1, 2, 3, 4, 5]
        }
    },
    props: {
        rating: {type: Number, required: false},
        showHalf: {type: Boolean, required: false, default: false},
        size: {type: String, required: false, default: '1.5em'},
        color: {type: String, required: false, default: ''}
    }
}
</script>
<style scoped>
    .empty {
        color: #AAAAAB;
        opacity: 0.35;
    }
    .totalizer.global .empty {
        color: #FFB366;
        opacity: 0.35;
    }
    .positive, .rating-category .colapse-rating-tags .positive {
        color: #FFB366;
        opacity: 0.35;
    }
    .rating-category .positive {
        color: #FFB366;
    }
    .negative {
        color: #BF5868;
        opacity: 0.35;
    }
    i.fa-star:not(:last-child) {
        margin-right: 2px;
    }
    .active {
        opacity: 1 !important;
    }

    @media screen and (max-width: 991px) {
        .rating-category i {
            margin-right: 1.5px;
        }
    }
</style>